import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useLocation } from 'react-router-dom';
import Footer from "../components/Footer";
import "../styles/select-plan.scss";

function Error() {
    document.title="iWantTFC - Discover | Error";
    const location = useLocation();
    const params = location.state;

    return (
        <div className="body">
            <Header />
            <div className="error-container">
                <p>
                    {params.message}
                </p>
                <p>Click <Link to={process.env.REACT_APP_IWANTTFC_HOMEPAGE}>here</Link> to go back to the home page.</p>
            </div>

            <Footer />
        </div>
    );
}

export default Error;